import { Box } from '@mui/material'
import { PropsWithChildren } from 'react'
import { useMobileView } from '../../../Hooks/useMobileView';

const DashboardLayout = ({children}: PropsWithChildren) => {
    /* ******************** Hooks ******************** */
    const { flexDirection } = useMobileView();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Box
            marginTop={2} 
            height={'100%'} 
            columnGap={'2%'} 
            display={"flex"} 
            flexDirection={flexDirection}
            sx={{
                ' > .DashboardColumn': {
                    flexDirection: 'column',
                    height: 'fit-content',
                    maxWidth: '388px',
                    minWidth: '308px',
                    '> .KaziJobCard': {
                        marginBottom: 2
                    }
                }
            }}
        >
            {children}
        </Box>
    )
}

export default DashboardLayout;
